import { render, staticRenderFns } from "./setModel.vue?vue&type=template&id=2b8badee&"
import script from "./setModel.vue?vue&type=script&lang=js&"
export * from "./setModel.vue?vue&type=script&lang=js&"
import style0 from "./setModel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "setModel.vue"
export default component.exports